import { TypePaymentStatus } from '../models/TransferReservationPartial';
import {
  faCheckCircle,
  faClock,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

export const STATUS_COLORS = {
  CREATED: '#001DAB',
  PENDING: '#DB6100', 
  APPROVED: '#005700',
  CANCELLED: '#9C0000',
  REJECTED: '#9C0000'
} as const;

export const STATUS_TEXT_SHADOWS = {
  CREATED: '1px 1px 1px rgba(136, 43, 255, 0.5)',
  PENDING: '1px 1px 1px rgba(255, 208, 0, 0.5)',
  APPROVED: '1px 1px 1px rgba(0, 255, 0, 0.5)',
  CANCELLED: '1px 1px 1px rgba(255, 0, 0, 0.5)',
  REJECTED: '1px 1px 1px rgba(255, 0, 0, 0.5)'
} as const;

export const STATUS_BOX_SHADOWS = {
  CREATED: '0px 0px 8px rgba(136, 43, 255)',
  PENDING: '0px 0px 8px rgba(255, 208, 0)',
  APPROVED: '0px 0px 8px rgba(0, 255, 0)',
  CANCELLED: '0px 0px 8px rgba(255, 0, 0)',
  REJECTED: '0px 0px 8px rgba(255, 0, 0)'
} as const;

export interface PaymentStatusConfig {
  text: string;
  color: string;
  backgroundColor: string;
  borderColor: string;
  textShadow: string;
  boxShadow: string;
  icon: any;
}

export const PAYMENT_STATUS_CONFIG: Record<TypePaymentStatus, PaymentStatusConfig> = {
  [TypePaymentStatus.CREATED]: {
    text: 'Creado',
    color: STATUS_COLORS.CREATED,
    backgroundColor: STATUS_COLORS.CREATED,
    borderColor: STATUS_COLORS.CREATED,
    textShadow: STATUS_TEXT_SHADOWS.CREATED,
    boxShadow: STATUS_BOX_SHADOWS.CREATED,
    icon: faCheckCircle
  },
  [TypePaymentStatus.PENDING]: {
    text: 'Pendiente',
    color: STATUS_COLORS.PENDING,
    backgroundColor: STATUS_COLORS.PENDING,
    borderColor: STATUS_COLORS.PENDING,
    textShadow: STATUS_TEXT_SHADOWS.PENDING,
    boxShadow: STATUS_BOX_SHADOWS.PENDING,
    icon: faClock
  },
  [TypePaymentStatus.APPROVED]: {
    text: 'Pagado',
    color: STATUS_COLORS.APPROVED,
    backgroundColor: STATUS_COLORS.APPROVED,
    borderColor: STATUS_COLORS.APPROVED,
    textShadow: STATUS_TEXT_SHADOWS.APPROVED,
    boxShadow: STATUS_BOX_SHADOWS.APPROVED,
    icon: faCheckCircle
  },
  [TypePaymentStatus.PAID]: {
    text: 'Pagado Manual',
    color: STATUS_COLORS.APPROVED,
    backgroundColor: STATUS_COLORS.APPROVED,
    borderColor: STATUS_COLORS.APPROVED,
    textShadow: STATUS_TEXT_SHADOWS.APPROVED,
    boxShadow: STATUS_BOX_SHADOWS.APPROVED,
    icon: faCheckCircle
  },
  [TypePaymentStatus.CANCELLED]: {
    text: 'Cancelado',
    color: STATUS_COLORS.CANCELLED,
    backgroundColor: STATUS_COLORS.CANCELLED,
    borderColor: STATUS_COLORS.CANCELLED,
    textShadow: STATUS_TEXT_SHADOWS.CANCELLED,
    boxShadow: STATUS_BOX_SHADOWS.CANCELLED,
    icon: faTimesCircle
  },
  [TypePaymentStatus.REJECTED]: {
    text: 'Rechazado',
    color: STATUS_COLORS.REJECTED,
    backgroundColor: STATUS_COLORS.REJECTED,
    borderColor: STATUS_COLORS.REJECTED,
    textShadow: STATUS_TEXT_SHADOWS.REJECTED,
    boxShadow: STATUS_BOX_SHADOWS.REJECTED,
    icon: faTimesCircle
  }
};

export const getPaymentStatusConfig = (status: TypePaymentStatus): PaymentStatusConfig => {
  return PAYMENT_STATUS_CONFIG[status];
};

export const getPaymentStatusColor = (status: TypePaymentStatus) => {
  const config = getPaymentStatusConfig(status);
  return {
    color: config.color,
    backgroundColor: config.backgroundColor,
    borderColor: config.borderColor,
    textShadow: config.textShadow,
    boxShadow: config.boxShadow
  };
};
